import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, Activity, FileText, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

export function QuickActionsWidget() {
  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Common administrative tasks</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2 flex-1 overflow-auto">
        <Link to="/admin/users">
          <Button variant="outline" className="w-full justify-start">
            <Users className="h-4 w-4 mr-2" />
            Manage Users
          </Button>
        </Link>
        <Link to="/admin/analytics">
          <Button variant="outline" className="w-full justify-start">
            <Activity className="h-4 w-4 mr-2" />
            View Analytics
          </Button>
        </Link>
        <Link to="/admin/claims">
          <Button variant="outline" className="w-full justify-start">
            <FileText className="h-4 w-4 mr-2" />
            Review Placement
          </Button>
        </Link>
        <Link to="/admin/messages">
          <Button variant="outline" className="w-full justify-start">
            <MessageSquare className="h-4 w-4 mr-2" />
            Support Inbox
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
}
